import styles from './EntityPicker.module.scss';

import { Stack } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { Order } from '@work4all/models/lib/Classes/Order.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { ListEntityPicker } from './components/list-entity-picker/ListEntityPicker';
import { IPickerProps } from './types';

export type OrderPickerProps<TMultiple extends boolean> = IPickerProps<
  Order,
  TMultiple
>;

export function OrderPicker<TMultiple extends boolean>(
  props: OrderPickerProps<TMultiple>
) {
  const { data, ...rest } = props;
  const allFields = useMemo(() => {
    return { ...DATA, ...data };
  }, [data]);

  const renderItem = (item: Order) => {
    const label = item.note;

    return (
      <Tooltip title={label}>
        <Stack
          direction="row"
          justifyContent="space-between"
          style={{ width: '100%' }}
        >
          <Typography variant="body2" noWrap flex="3">
            {label}
          </Typography>
          <Typography
            variant="body2"
            noWrap
            className={styles.secondaryInfo}
            flex="1"
          >
            {item.number}
          </Typography>
          <Typography variant="body2" noWrap flex="1">
            {DateTime.fromISO(item.date).toFormat('dd.MM.yyyy')}
          </Typography>
        </Stack>
      </Tooltip>
    );
  };

  return (
    <ListEntityPicker
      entity={Entities.order}
      data={allFields}
      filterBy={['number', 'note']}
      sortBy="date"
      sortByDirection={SortDirection.DESCENDING}
      {...rest}
      renderItemContent={renderItem}
      renderChipContent={(el: Order) => el.note}
    />
  );
}

const DATA: Order = {
  id: null,
  date: null,
  number: null,
  note: null,
};
